// register plugins
import './plugins/class-component-hooks';
import './registerServiceWorker';
import '@/plugins/app-config';
import '@/plugins/vue-notifications';
import '@/plugins/vue-qrcode-reader';
import '@/plugins/vue-qriously';
import '@/plugins/vuetify-loader';
import '@babel/polyfill';

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import VeeValidate from 'vee-validate';
import Vue from 'vue';

import App from './App.vue';
import { Vuelux } from './plugins/vuelux';
import Router from './router';
import Store from './store';

Vue.config.productionTip = false;
Vue.use(Vuelux);
Vue.use(VeeValidate);

Sentry.init({
  dsn: 'https://c52cb31f7c054d4d87cf7ba5cdf562c8@sentry.luxtag.io/5',
  integrations: [new Integrations.Vue({Vue, attachProps: true, logErrors: true})],
  environment: process.env.NODE_ENV
});

new Vue({
  $_veeValidate: {
    validator: 'new'
  },
  router: Router,
  store: Store,
  render: (h) => h(App),
}).$mount('#app');
